import StudentReferee from "./src/main";

StudentReferee.install = function (Vue) {
  Vue.component(StudentReferee.name, StudentReferee);
};

export default StudentReferee;
